var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DrawerLandingCity',{attrs:{"imgUrl":_vm.formItem.icon_url,"omegaItem":_vm.omegaItem,"title":_vm.formItem.title,"areaClassError":_vm.areaClassError},on:{"changeCity":_vm.getPageConf}})}
var staticRenderFns = []

export { render, staticRenderFns }